import { render } from "./TaskStatus.vue?vue&type=template&id=70d472ec&ts=true"
import script from "./TaskStatus.vue?vue&type=script&lang=ts"
export * from "./TaskStatus.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__